import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Tag from '../../../Tags/Tag';
import enterAltitude from '../../../../assets/recommended/enterAltitudeP.png';
import { setCurrentCourse } from '../../../../store/actions/appActions';
import { COURSES } from '../../../../constants/courses';
import { CoursesModifications } from '../../../../types/courses/courses';

import { RestoreWrapper, TagsWrapper, RestoreImage, RestoreContent, RestoreBottom } from './styled';
import useMediaQuery from '../../../../utils/breakpoints/useMediaQuery';

const EnterAltitudeProgressio = () => {
   const { t } = useTranslation();
   const dispatch = useDispatch();
   const { isMobile } = useMediaQuery();

   const handleSelectCourse = () => {
      dispatch(setCurrentCourse({ courseModification: COURSES.enterAltitudeProposal as CoursesModifications }));
   }

   return (
      <Link to={`/cabinet/${COURSES.enterAltitudeProposal}`} >
         <RestoreWrapper onClick={handleSelectCourse} isMobile={isMobile}>
            <RestoreImage isMobile={isMobile} src={enterAltitude} />
            <RestoreContent isMobile={isMobile} >
               <TagsWrapper>
                  <Tag name="Kids" />
               </TagsWrapper>
               <RestoreBottom isMobile={isMobile}> 
                  <h1>{t('course.enterAltitudeProposal.title')}</h1>
                  <p>{t('course.enterAltitudeProposal.description')}</p>
            </RestoreBottom>  
            </RestoreContent>
         </RestoreWrapper>
      </Link>
   );
};

export default EnterAltitudeProgressio;